import { Component, ViewEncapsulation, ViewChild, ElementRef, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class HomeComponent implements OnInit {

	@ViewChild('target') target: ElementRef;

	constructor(private _titleService: Title, private _meta: Meta) {
		this._titleService.setTitle( 'Hospital Veterinário Stolf');
	}

	ngOnInit() {
		this._meta.addTag({
			name: 'title',
			content: 'Hospital Veterinário Stolf - Lages SC'
		});
		this._meta.addTag({
			name: 'description',
			content: 'O Hospital Veterinário Stolf tem como objetivo solucionar problemas, proporcionar saúde e bem estar aos animais e satisfazer os clientes, tornando a relação entre ambos harmônica e saudável'
		});
	}

	public scrollElement() {
		this.target.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
	}

}



// WEBPACK FOOTER //
// /Users/henriquezanini/Sites/Cães e Gatos/site/src/app/home/home.component.ts